import * as React from 'react';
import * as d3 from 'd3';
import { isWeekend } from 'date-fns';
import * as XAxisElements from './XAxis.styles';
import { useCanvas } from '../Canvas';
import { intervalAndFormat } from '../IntervalGuides/IntervalGuides.utils';
function textAnchorStyle(ticks, index) {
    if (index === 0)
        return { textAnchor: 'start' };
    if (index === ticks.length - 1)
        return { textAnchor: 'end' };
    return { textAnchor: 'middle' };
}
export var XAxis = function (_a) {
    var label = _a.label, xDomain = _a.xDomain, _b = _a.ticksAbove, ticksAbove = _b === void 0 ? false : _b;
    var dims = useCanvas();
    var scale = d3.scaleTime().domain(xDomain).range([0, dims.boundedWidth]);
    var _c = intervalAndFormat(scale.domain()), format = _c.format, tickCount = _c.tickCount;
    var ticks = scale.ticks(tickCount);
    var tickPosStyle = {
        offset: ticksAbove ? -25 + dims.boundedHeight : 18,
        y1: ticksAbove ? 9 + dims.boundedHeight : 9,
        y2: ticksAbove ? 15 + dims.boundedHeight : 15
    };
    var axisLine = {
        y: ticksAbove ? dims.boundedHeight : 0
    };
    return (React.createElement(XAxisElements.XAxisBase, null,
        React.createElement("line", { x2: dims.boundedWidth, y1: axisLine.y, y2: axisLine.y }),
        ticks.map(function (tick, index) { return (React.createElement("g", { key: tick.getTime(), style: {
                transform: "translate(" + String(scale(tick)) + "px, " + tickPosStyle.offset + "px)"
            } },
            React.createElement("g", { style: {
                    transformOrigin: '0 0'
                } },
                React.createElement("line", { className: "XAxis--TickMark", y1: ticksAbove ? 14 : -12, y2: ticksAbove ? 24 : -18 }),
                React.createElement(XAxisElements.XAxisTick, { style: textAnchorStyle(ticks, index), isWeekend: isWeekend(tick) }, format(tick))))); }),
        label !== undefined && (React.createElement("text", { className: "Axis__label", transform: "translate(" + dims.boundedWidth / 2 + ", 90)" }, label))));
};
//# sourceMappingURL=XAxis.js.map